export const getEventsBegin = "GET_EVENTS_BEGIN";
export const getEventsSuccess = "GET_EVENTS_SUCCESS";
export const getEventsFailure = "GET_EVENTS_FAILURE";
export const resetEvents = "RESET_EVENTS";
